import React from 'react';

import { DigitalDollarDetails } from '@/Screens/Dashboard/Home/DigitalDollarDetails';
import { WalletDetails } from '@/Screens/Dashboard/Home/WalletDetails';
import { CurrencyCodeType } from '@/types/currency';

interface Props {
  readonly currency: CurrencyCodeType;
}

export const AccountDetailsModal: React.FC<Props> = (props: Props): React.ReactElement => {
  const { currency } = props;

  switch (currency) {
    case CurrencyCodeType.USDC:
      return <DigitalDollarDetails />;

    case CurrencyCodeType.USDT:
      return <WalletDetails currency={currency} />;

    default:
      console.warn('unsupported currency, cannot show details for: ', currency);
      return <></>;
  }
};
